module.exports = __webpack_public_path__ + "static/media/hotelPageMonitoringIcon.3d523352.png";